<!-- <div class="overlay" [class.active]="enabled">
    <div class="overlay-background"></div>
    <div class="overlay-content">
        <span class="spinner"></span>&nbsp;&nbsp;Loading...
    </div>
</div> -->


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#fff" type="ball-scale-multiple">
</ngx-spinner>